<template>
  <div>
    <div class="filter-btn" @click="openHandler">
      <div class="filter-btn__title">
        <span>Клиники</span>
        <span v-if="clearble || !isAllSelected"
          >Выбрано: <span>{{ syncSelected.length }}</span>
        </span>
        <span v-else>Все</span>
      </div>
      <div class="filter-btn__icons">
        <CloseRoundIcon
          :onClose="resetFilter"
          v-if="clearble || !isAllSelected"
          class="filter-btn__icons-reset"
        />
        <span v-if="clearble || !isAllSelected" class="devider"></span>
        <LocateIcon />
      </div>
    </div>
    <div v-if="isOpen">
      <div @click.stop="closeModalHanlder" class="modal__backdrop"></div>
      <div class="modal">
        <div v-if="display.smAndDown" class="mobile-header">
          <span>Клиники</span>
          <div @click="closeModalHanlder" class="mobile-header__icon">
            <CloseBoldIcon />
          </div>
        </div>
        <div v-if="display.smAndDown" class="modal__change">
          <div @click="checkMode = true" :class="[checkMode && '--selected']">
            Списком
          </div>
          <div @click="checkMode = false" :class="[!checkMode && '--selected']">
            На карте
          </div>
        </div>
        <div v-if="!checkMode" class="map-container--mobile">
          <SmMapComponent
            :initMap="(v) => (this.map = v)"
            :location="location"
            :coords="currCoords"
            :markers="computedMarkers"
            :markerClickHandler="showClinicInfo"
          />
          <MapControls :zoom="updateZoom" :geolocation="toUserLocation" />

          <Transition name="fade">
            <ClinicModal
              v-if="isOpenClinicModal"
              :item="computedClinicModalItem"
              @onClose="closeClinicModalHandler"
              @changeClinic="chageClinic"
              @removeClinic="removeClinic"
            />
          </Transition>

          <div class="selected-counter" v-if="syncSelected.length">
            <span>Выбрано: {{ syncSelected.length }}</span>
            <Button :onClick="applyFilter">Применить</Button>
          </div>
        </div>
        <CheckList
          v-if="display.smAndDown && checkMode"
          v-model="syncSelected"
          :items="items"
          :onSubmit="applyFilter"
        />
        <div v-if="!display.smAndDown" class="clinic-list">
          <CheckList
            class="list-container"
            v-model="syncSelected"
            :items="items"
            :onSubmit="applyFilter"
          />

          <div class="map-container">
            <SmMapComponent
              :initMap="(v) => (this.map = v)"
              :location="location"
              :coords="currCoords"
              :markers="computedMarkers"
              :markerClickHandler="showClinicInfo"
            />
            <MapControls :zoom="updateZoom" :geolocation="toUserLocation" />

            <Transition name="fade">
              <template v-if="isOpenClinicModal">
                <ClinicModal
                  :item="computedClinicModalItem"
                  @onClose="closeClinicModalHandler"
                  @changeClinic="chageClinic"
                  @removeClinic="removeClinic"
                />
              </template>
            </Transition>
          </div>
        </div>
        <CloseIcon
          v-if="!display.smAndDown"
          :onClose="closeModalHanlder"
          class="modal__close-icon"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { computed, ref, toRefs } from '@vue/composition-api'

import SmMapComponent from '@/components/mapComponents/map'
import Button from '@/components/button'
import SmSlideLocation from '@/components/slideOutComponents/location/location'
import MapControls from '@/components/mapComponents/mapControls'

import CheckList from './components/checkList'
import ClinicModal from './components/ClinicModal'

import CloseRoundIcon from '@/assets/icons/close-round'
import LocateIcon from '@/assets/icons/locate'
import CloseIcon from '@/assets/icons/close'
import CloseBoldIcon from '@/assets/icons/close-bold.vue'
import { useDisplay } from '@/hooks'

export default {
  name: 'clinic-filter',
  components: {
    CloseRoundIcon,
    LocateIcon,
    CloseIcon,
    CheckList,
    SmMapComponent,
    CloseBoldIcon,
    ClinicModal,
    MapControls,
    Button
  },
  props: ['items', 'title', 'value', 'clearble'],
  computed: {
    syncSelected: {
      get() {
        return this.value ?? []
      },
      set(v) {
        this.$emit('input', v)
      }
    }
  },
  setup(props, ctx) {
    const { items, value } = toRefs(props)
    const display = useDisplay()

    const clinicModalItem = ref(null)

    const computedClinicModalItem = computed(function () {
      const selectedElem = this.syncSelected.find(
        (v) => v.id === clinicModalItem.value.id
      )

      return { ...clinicModalItem.value, status: selectedElem }
    })

    const isOpenClinicModal = ref(false)

    const checkMode = ref(true)

    let stashSelected = []

    const isOpen = ref(false)
    const markers = ref([])
    const map = ref(null)
    const location = ref(null)
    const currCoords = ref(null)

    const computedMarkers = computed(function () {
      return markers.value.map((marker) => {
        if (clinicModalItem.value) {
          if (marker.id === clinicModalItem.value.id) {
            return { ...marker, isOpen: true }
          }
        }

        if (this.syncSelected.length) {
          const selectedElem = this.syncSelected.find((v) => v.id === marker.id)
          if (selectedElem) {
            return { ...marker, status: 'selected' }
          }
        }

        return marker
      })
    })

    const isAllSelected = computed(() => {
      if (value.value) {
        return value.value.length === items.value.length
      }
      return false
    })

    function showClinicInfo(ev) {
      const clinic = props.items.find((el) => el.id === ev.id)

      clinicModalItem.value = { ...clinic, status: ev.status }
      isOpenClinicModal.value = true
    }

    function applyFilter() {
      this.$emit('submit')
      isOpen.value = false
      document.body.style.overflow = ''
    }

    function openHandler() {
      stashSelected = value.value

      const cityUser = JSON.parse(localStorage.getItem('city'))

      if (cityUser.cities.selected === '00000000-0000-0000-0000-000000000000') {
        this.$showPanel({
          component: 'SmSlideoutPanel',
          props: {
            title: 'Выберите город',
            component: SmSlideLocation,
            properties: {
              value: { title: 'Город не найден' }
            }
          },
          openOn: 'right',
          sync: true,
          keepAlive: false
        })
        return
      }

      markers.value = items.value.map((el) => ({
        ...el,
        status: null
      }))

      isOpen.value = true
      document.body.style.overflow = 'hidden'
    }

    function closeModalHanlder() {
      isOpen.value = false
      document.body.style.overflow = ''
      if (JSON.stringify(stashSelected) !== JSON.stringify(value.value)) {
        ctx.emit('input', stashSelected)
      }
    }

    function resetFilter() {
      ctx.emit('reset-filter')
      ctx.emit('input', items.value)
    }

    function closeClinicModalHandler() {
      if (!isOpenClinicModal.value) return
      clinicModalItem.value = null
      isOpenClinicModal.value = false
    }

    function chageClinic(item) {
      const clinic = items.value.find((v) => v.id === item.id)
      this.syncSelected = [...this.syncSelected, clinic]
    }

    function removeClinic(item) {
      this.syncSelected = this.syncSelected.filter((el) => el.id !== item.id)
    }

    function updateZoom(zoomIn) {
      const zoom = map.value.getZoom()
      zoomIn ? map.value.setZoom(zoom + 1) : map.value.setZoom(zoom - 1)
    }

    function toUserLocation() {
      navigator.geolocation.getCurrentPosition(({ coords }) => {
        location.value = currCoords.value = [coords.latitude, coords.longitude]
      })
    }

    return {
      isOpen,
      isAllSelected,
      markers,
      showClinicInfo,
      applyFilter,
      openHandler,
      closeModalHanlder,
      resetFilter,
      display,
      checkMode,
      isOpenClinicModal,
      clinicModalItem,
      closeClinicModalHandler,
      computedMarkers,
      chageClinic,
      removeClinic,
      computedClinicModalItem,
      updateZoom,
      toUserLocation,
      map,
      location,
      currCoords
    }
  }
}
</script>
<style lang="scss" scoped>
@import 'style';
</style>
